import { render, staticRenderFns } from "./history-search.vue?vue&type=template&id=367ea70a&"
import script from "./history-search.vue?vue&type=script&lang=js&"
export * from "./history-search.vue?vue&type=script&lang=js&"
import style0 from "./history-search.vue?vue&type=style&index=0&id=367ea70a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports